import {Spin} from 'antd';
import cn from 'classnames';
import React, {CSSProperties, FC} from 'react';

import s from './spinner.module.less';

interface ISpinnerClassNames {
    containerClassName: string;
}

interface ISpinnerProps {
    tip?: string;
    style?: CSSProperties;
    classNames?: ISpinnerClassNames;
}

const DEFAULT_TIP = 'Загрузка...';

export const Spinner: FC<ISpinnerProps> = ({
    tip = DEFAULT_TIP,
    style,
    classNames,
}: ISpinnerProps) => (
    <div className={cn(
        s['spinner-container'],
        classNames?.containerClassName && s[classNames.containerClassName],
    )}
    >
        <Spin
            style={style}
            tip={tip}
        />
    </div>
);
